import { HighlightCard } from 'src/components/templates/HighlightCardTemplate';
import { RadarChartBox, TextBox } from './styles';
import { Text } from '#atoms';

interface RadarChartProps {
  data: number[];
  labels: string[];
  size?: number;
}

export const RadarChart = ({ data, labels, size = 287 }: RadarChartProps) => {
  const center = size / 2;
  const angleStep = (2 * Math.PI) / labels.length;
  const radius = center * 0.7;
  const rotationOffset = Math.PI / 8; // 22.5도 회전

  // 데이터 포인트의 최대값을 찾습니다.
  const maxValue = Math.max(...data) + 10; // 최대 값보다 넓은 범위 지정
  const normalizedRadius = radius; // 원래 반지름을 사용

  // 데이터 포인트 설정
  const points = data.map((value, index) => {
    const normalizedValue = value / maxValue; // 데이터 값을 비율로 변경
    const angle = index * angleStep - Math.PI / 2 + rotationOffset;

    // const x = center + radius * (value / 100) * Math.cos(angle);
    // const y = center + radius * (value / 100) * Math.sin(angle);

    const x = center + normalizedRadius * normalizedValue * Math.cos(angle);
    const y = center + normalizedRadius * normalizedValue * Math.sin(angle);
    return `${x},${y}`;
  });
  const polygonPoints = points.join(' ');

  // 안쪽 그리드 라인
  const gridLines = labels.map((_, index) => {
    const angle = index * angleStep - Math.PI / 2 + rotationOffset;
    const x = center + radius * Math.cos(angle);
    const y = center + radius * Math.sin(angle);
    return (
      <line
        key={index}
        x1={center}
        y1={center}
        x2={x}
        y2={y}
        stroke="#2e2b36"
        strokeWidth="1"
      />
    );
  });

  // 동심원 라인 대신 폴리곤 형태의 그리드
  const concentricPolygons = () => {
    const gridRadius = (radius * (4 + 1)) / 5;
    const gridPoints = labels
      .map((_, index) => {
        const angle = index * angleStep - Math.PI / 2 + rotationOffset;
        const x = center + gridRadius * Math.cos(angle);
        const y = center + gridRadius * Math.sin(angle);
        return `${x},${y}`;
      })
      .join(' ');
    return (
      <polygon
        points={gridPoints}
        fill="none"
        stroke="#2e2b36"
        strokeWidth="1"
      />
    );
  };

  // 라벨 위치 설정
  const labelElements = labels.map((label, index) => {
    const angle = index * angleStep - Math.PI / 2 + rotationOffset;
    let x = center + (radius + 20) * Math.cos(angle);
    let y = center + (radius + 20) * Math.sin(angle);

    // 위치에 따라 라벨 위치를 조정
    if (index === 0) {
      // 상단 오른쪽
      y -= 10;
    } else if (index === 1) {
      // 우측 상단
      x += 10;
      y -= 5;
    } else if (index === 2) {
      // 우측 하단
      x += 10;
      y -= 10;
    } else if (index === 3) {
      // 하단 우측
    } else if (index === 4) {
      // 하단 좌측
    } else if (index === 5) {
      // 좌측 하단
      x -= 10;
      y -= 10;
    } else if (index === 6) {
      // 좌측 상단
      x -= 10;
      y -= 5;
    } else if (index === 7) {
      // 상단 좌측
      y -= 10;
    }

    return (
      <>
        <text
          key={index}
          x={x}
          y={y}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#8e899f"
          fontSize="12"
        >
          {label}
        </text>
        <text
          key={index}
          x={x + 2}
          y={y + 15}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#eae8ed"
          fontSize="13"
        >
          50%
        </text>
      </>
    );
  });

  return (
    <HighlightCard>
      <TextBox>
        <Text
          style={{
            color: 'var(--color-gray-text2)',
            fontSize: '1.4rem',
            lineHeight: '2rem'
          }}
        >
          운동 차트
        </Text>
        <Text
          textStyle="bb"
          style={{
            fontSize: '2rem',
            color: '#EAE8ED',
            lineHeight: '2.6rem',
            textAlign: 'center',
            fontWeight: 700
          }}
        >
          이렇게 운동했어요!
        </Text>
      </TextBox>
      <RadarChartBox>
        <svg width={size} height={size}>
          {concentricPolygons()}
          {gridLines}
          <polygon
            points={polygonPoints}
            fill="rgba(119, 80, 233, 0.2)"
            stroke="rgba(119, 80, 233, 1)"
            strokeWidth="2"
          />
          {labelElements}
        </svg>
      </RadarChartBox>
    </HighlightCard>
  );
};
